'use client'

import { Box, Flex, Stack } from '@/styled-system/jsx'
import { Portal } from '@ark-ui/react'
import { useEffect, useState } from 'react'
import LoadingIcon from '../icons/loading'

export default function Loader() {
  const [progress, setProgress] = useState(8)

  useEffect(() => {
    const timeout = window.setTimeout(() => {
      setProgress(100)
    }, 450)

    return () => {
      window.clearTimeout(timeout)
    }
  }, [])

  return (
    <Flex align='center' justify='center'>
      <Stack gap={10} alignItems='center'>
        <Flex
          position='relative'
          align='center'
          justify='center'
          w={{ base: '120px', md: '150px' }}
          h={{ base: '120px', md: '150px' }}
        >
          <LoadingIcon size={100} />
        </Flex>
      </Stack>
    </Flex>
  )
}
